import { useInterviewerNavigation } from '@/composable/nav/useInterviewerNavigation'
import { useOrganisationNavigation } from '@/composable/nav/useOrganisationNavigation'
import { useAuthStore } from '@/stores/auth'

export function useTopbarNavItems() {
  const authStore = useAuthStore()

  const { navItems: organisationNavItems } = useOrganisationNavigation()
  const { navItems: interviewerNavItems } = useInterviewerNavigation()

  return {
    organisationNavItems: computed(() => authStore.selected_organisation_id ? organisationNavItems.value : []),
    interviewerNavItems: computed(() => interviewerNavItems.value),
  }
}
